(() => {
  const PAGE_SIZE = 4;

  document.querySelectorAll('.hp-reviews-hg__layout').forEach((section) => {
    const filters       = section.querySelectorAll('.hp-reviews-hg__filter');
    const allCards      = Array.from(section.querySelectorAll('.hp-reviews-hg__card'));
    const dotsContainer = section.querySelector('.hp-reviews-hg__dots');
    const cardsWrap     = section.querySelector('.hp-reviews-hg__cards');
    const prevBtn       = section.querySelector('.hp-reviews-hg__nav-prev');
    const nextBtn       = section.querySelector('.hp-reviews-hg__nav-next');
    const nav           = section.querySelector('.hp-reviews-hg__nav');
    const ctaLink       = section.querySelector('.hp-reviews-hg__cta');
    const ctaBase       = section.dataset.ctaBase || '/collections/all-products';

    if (!cardsWrap) return;

    let currentPage = 0;
    let dots = [];

    const isDesktop = () => window.innerWidth >= 769;
    const getVisibleCards = () => allCards.filter((c) => !c.hidden);

    // ── Dots ──────────────────────────────────────────────────────────────────

    function buildDots(count) {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('span');
        dot.className = 'hp-reviews-hg__dot';
        dotsContainer.appendChild(dot);
      }
      dots = Array.from(dotsContainer.querySelectorAll('.hp-reviews-hg__dot'));
    }

    function updateDots(activeIndex) {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }

    const dotCount = (visibleCount) => isDesktop() ? Math.ceil(visibleCount / PAGE_SIZE) : visibleCount;

    // ── Desktop slider ─────────────────────────────────────────────────────────

    const getCardStep = () => {
      const containerWidth = cardsWrap.offsetWidth;
      return (containerWidth - (PAGE_SIZE - 1) * 20) / PAGE_SIZE + 20;
    };

    function syncNav(page, totalPages) {
      if (nav) nav.style.display = totalPages > 1 ? '' : 'none';
      if (prevBtn) prevBtn.disabled = page === 0;
      if (nextBtn) nextBtn.disabled = page >= totalPages - 1;
    }

    function goToPage(page) {
      const visible = getVisibleCards();
      const totalPages = Math.ceil(visible.length / PAGE_SIZE);
      currentPage = Math.min(Math.max(0, page), totalPages - 1);
      cardsWrap.style.transform = `translateX(-${currentPage * PAGE_SIZE * getCardStep()}px)`;
      updateDots(currentPage);
      syncNav(currentPage, totalPages);
    }

    // ── Mobile carousel ────────────────────────────────────────────────────────

    const getCardStepMobile = () => {
      const first = cardsWrap.querySelector('.hp-reviews-hg__card:not([hidden])');
      return first ? first.offsetWidth + 10 : 1;
    };

    cardsWrap.addEventListener('scroll', () => {
      if (isDesktop()) return;
      const index = Math.round(cardsWrap.scrollLeft / getCardStepMobile());
      updateDots(index);
    }, { passive: true });

    // ── Prev / Next ───────────────────────────────────────────────────────────

    prevBtn?.addEventListener('click', () => {
      if (isDesktop()) goToPage(currentPage - 1);
      else cardsWrap.scrollBy({ left: -getCardStepMobile(), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      if (isDesktop()) goToPage(currentPage + 1);
      else cardsWrap.scrollBy({ left: getCardStepMobile(), behavior: 'smooth' });
    });

    // ── Filter tabs ───────────────────────────────────────────────────────────

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        const category = btn.dataset.category;

        filters.forEach((f) => {
          f.classList.remove('is-active');
          f.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        allCards.forEach((card) => {
          card.hidden = card.dataset.category !== category;
        });

        if (ctaLink) ctaLink.href = `${ctaBase}#${category}`;

        currentPage = 0;
        cardsWrap.style.transition = 'none';
        cardsWrap.style.transform = 'translateX(0)';
        cardsWrap.scrollLeft = 0;
        requestAnimationFrame(() => { cardsWrap.style.transition = ''; });

        const visible = getVisibleCards();
        buildDots(dotCount(visible.length));
        updateDots(0);
        if (isDesktop()) syncNav(0, Math.ceil(visible.length / PAGE_SIZE));
      });
    });

    // ── Init ──────────────────────────────────────────────────────────────────

    const visible = getVisibleCards();
    buildDots(dotCount(visible.length));
    updateDots(0);
    if (isDesktop()) syncNav(0, Math.ceil(visible.length / PAGE_SIZE));
  });
})();
